import {Component, OnInit} from '@angular/core';
import {DecisionsService} from "./decisions.service";
import {ViewManagerService} from "../../services/view-manager.service";
import {SessionManagerService} from "../../services/session-manager.service";

@Component({
  selector: 'admin-decisions',
  templateUrl: './decisions.component.html',
  styleUrls: ['./decisions.component.css']
})
export class DecisionsComponent implements OnInit {

  constructor(
    private decisionsService: DecisionsService,
    private viewManager: ViewManagerService
  ) {

  }
  ngOnInit(): void {
    this.decisionsService.list();
  }

  definitions() {
    return this.decisionsService.getDefinitions();
  }

}
